import { Box, BoxProps } from '@material-ui/core';
import { GridPricing, Product } from '@setvi/shared/interfaces';
import { STextProps } from '@setvi/shared/components/sui/stext';
import { getGridProductDetailsPricing } from '../../../../../price/full/components/pricing/utils';

interface FullContentProps extends BoxProps {
  product: Product;
  pricing: GridPricing[];
  fontSize?: STextProps['size'];
}
export const FullContent = ({
  product,
  pricing,
  fontSize,
  style,
  ...rest
}: FullContentProps) => (
  <Box
    style={{
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      rowGap: '8px',
      ...style
    }}
    {...rest}>
    {pricing.map(i => (
      <span
        key={i.label}
        style={{
          flex: '1 1 auto',
          display: 'flex',
          ...(i.fullWidth && { width: '100%' }),
          justifyContent: i.align || 'start'
        }}>
        {getGridProductDetailsPricing({ pricing: i, product, fontSize })}
      </span>
    ))}
  </Box>
);
